<template>
  <div class="main-container flex flex-center">
    <div class="main-box">
      <!--头部导航-->
      <div class="box-header flex flex-center">
        <div class="box-header-left flex flex-center">
          <span
            class="header-span"
            :class="{ 'header-span-active': active1 == 1 }"
            @click="active1 = 1"
            >按时间</span
          >
          <span
            class="header-span"
            :class="{ 'header-span-active': active1 == 2 }"
            @click="active1 = 2"
            >{{ $t("m.options.listTab.name") }}</span
          >
          <span
            class="header-span"
            :class="{ 'header-span-active': active1 == 3 }"
            @click="active1 = 3"
            >按机器</span
          >
          <span
            class="header-span"
            :class="{ 'header-span-active': active1 == 4 }"
            @click="active1 = 4"
            >{{ $t("m.options.listTab.star") }}</span
          >
        </div>
        <div class="box-header-right">
          <el-button
            type="primary"
            icon="el-icon-search"
            class="active-icon"
            @click="dialogTableVisible = true"
          ></el-button>
        </div>
      </div>
      <!--内容-->
      <div class="box-content" v-if="active1 == 1">
        <div class="box-item box-half box-active">
          <div class="box-state box-state-1"></div>
          <div class="box-item-img">
            <img src="../../assets/img/编组18@2x.png" />
            <div class="datetime">
              <el-rate
                :colors="['#FC9153', '#FC9153', '#FC9153']"
                v-model="star"
              ></el-rate>
            </div>
          </div>
          <div class="box-item-text">
            <div>
              <span class="text-title">名字：</span
              ><span class="text-value">导入杯测</span>
            </div>
            <div>
              <span class="text-title">烘焙度：</span
              ><span class="text-value">70%</span>
            </div>
            <div>
              <span class="text-title">得分：</span
              ><span class="text-value">57.69</span>
            </div>
            <div>
              <span class="text-title">登记：</span
              ><span class="text-value">良好</span>
            </div>
          </div>
        </div>
        <div class="box-item box-half">
          <div class="box-state box-state-2"></div>
          <div class="box-item-img">
            <img src="../../assets/img/编组18@2x.png" />
            <div class="datetime">
              <el-rate
                :colors="['#FC9153', '#FC9153', '#FC9153']"
                v-model="star"
              ></el-rate>
            </div>
          </div>
          <div class="box-item-text">
            <div>
              <span class="text-title">名字：</span
              ><span class="text-value">导入杯测</span>
            </div>
            <div>
              <span class="text-title">烘焙度：</span
              ><span class="text-value">70%</span>
            </div>
            <div>
              <span class="text-title">得分：</span
              ><span class="text-value">57.69</span>
            </div>
            <div>
              <span class="text-title">登记：</span
              ><span class="text-value">良好</span>
            </div>
          </div>
        </div>
        <div class="box-item box-half">
          <div class="box-state box-state-1"></div>
          <div class="box-item-img">
            <img src="../../assets/img/编组18@2x.png" />
            <div class="datetime">
              <el-rate
                :colors="['#FC9153', '#FC9153', '#FC9153']"
                v-model="star"
              ></el-rate>
            </div>
          </div>
          <div class="box-item-text">
            <div>
              <span class="text-title">名字：</span
              ><span class="text-value">导入杯测</span>
            </div>
            <div>
              <span class="text-title">烘焙度：</span
              ><span class="text-value">70%</span>
            </div>
            <div>
              <span class="text-title">得分：</span
              ><span class="text-value">57.69</span>
            </div>
            <div>
              <span class="text-title">登记：</span
              ><span class="text-value">良好</span>
            </div>
          </div>
        </div>
        <div class="box-item box-half">
          <div class="box-item-img">
            <img src="../../assets/img/编组18@2x.png" />
            <div class="datetime">
              <el-rate
                :colors="['#FC9153', '#FC9153', '#FC9153']"
                v-model="star"
              ></el-rate>
            </div>
          </div>
          <div class="box-item-text">
            <div>
              <span class="text-title">名字：</span
              ><span class="text-value">导入杯测</span>
            </div>
            <div>
              <span class="text-title">烘焙度：</span
              ><span class="text-value">70%</span>
            </div>
            <div>
              <span class="text-title">得分：</span
              ><span class="text-value">57.69</span>
            </div>
            <div>
              <span class="text-title">登记：</span
              ><span class="text-value">良好</span>
            </div>
          </div>
        </div>
        <div class="box-item box-half">
          <div class="box-item-img">
            <img src="../../assets/img/编组18@2x.png" />
            <div class="datetime">
              <el-rate
                :colors="['#FC9153', '#FC9153', '#FC9153']"
                v-model="star"
              ></el-rate>
            </div>
          </div>
          <div class="box-item-text">
            <div>
              <span class="text-title">名字：</span
              ><span class="text-value">导入杯测</span>
            </div>
            <div>
              <span class="text-title">烘焙度：</span
              ><span class="text-value">70%</span>
            </div>
            <div>
              <span class="text-title">得分：</span
              ><span class="text-value">57.69</span>
            </div>
            <div>
              <span class="text-title">登记：</span
              ><span class="text-value">良好</span>
            </div>
          </div>
        </div>
        <div class="box-item box-half">
          <div class="box-item-img">
            <img src="../../assets/img/编组18@2x.png" />
            <div class="datetime">
              <el-rate
                :colors="['#FC9153', '#FC9153', '#FC9153']"
                v-model="star"
              ></el-rate>
            </div>
          </div>
          <div class="box-item-text">
            <div>
              <span class="text-title">名字：</span
              ><span class="text-value">导入杯测</span>
            </div>
            <div>
              <span class="text-title">烘焙度：</span
              ><span class="text-value">70%</span>
            </div>
            <div>
              <span class="text-title">得分：</span
              ><span class="text-value">57.69</span>
            </div>
            <div>
              <span class="text-title">登记：</span
              ><span class="text-value">良好</span>
            </div>
          </div>
        </div>
        <div class="box-item box-half">
          <div class="box-item-img">
            <img src="../../assets/img/编组18@2x.png" />
            <div class="datetime">
              <el-rate
                :colors="['#FC9153', '#FC9153', '#FC9153']"
                v-model="star"
              ></el-rate>
            </div>
          </div>
          <div class="box-item-text">
            <div>
              <span class="text-title">名字：</span
              ><span class="text-value">导入杯测</span>
            </div>
            <div>
              <span class="text-title">烘焙度：</span
              ><span class="text-value">70%</span>
            </div>
            <div>
              <span class="text-title">得分：</span
              ><span class="text-value">57.69</span>
            </div>
            <div>
              <span class="text-title">登记：</span
              ><span class="text-value">良好</span>
            </div>
          </div>
        </div>
        <div class="box-item box-half">
          <div class="box-item-img">
            <img src="../../assets/img/编组18@2x.png" />
            <div class="datetime">
              <el-rate
                :colors="['#FC9153', '#FC9153', '#FC9153']"
                v-model="star"
              ></el-rate>
            </div>
          </div>
          <div class="box-item-text">
            <div>
              <span class="text-title">名字：</span
              ><span class="text-value">导入杯测</span>
            </div>
            <div>
              <span class="text-title">烘焙度：</span
              ><span class="text-value">70%</span>
            </div>
            <div>
              <span class="text-title">得分：</span
              ><span class="text-value">57.69</span>
            </div>
            <div>
              <span class="text-title">登记：</span
              ><span class="text-value">良好</span>
            </div>
          </div>
        </div>
        <div class="box-item box-half">
          <div class="box-item-img">
            <img src="../../assets/img/编组18@2x.png" />
            <div class="datetime">
              <el-rate
                :colors="['#FC9153', '#FC9153', '#FC9153']"
                v-model="star"
              ></el-rate>
            </div>
          </div>
          <div class="box-item-text">
            <div>
              <span class="text-title">名字：</span
              ><span class="text-value">导入杯测</span>
            </div>
            <div>
              <span class="text-title">烘焙度：</span
              ><span class="text-value">70%</span>
            </div>
            <div>
              <span class="text-title">得分：</span
              ><span class="text-value">57.69</span>
            </div>
            <div>
              <span class="text-title">登记：</span
              ><span class="text-value">良好</span>
            </div>
          </div>
        </div>
        <div class="box-item box-half">
          <div class="box-item-img">
            <img src="../../assets/img/编组18@2x.png" />
            <div class="datetime">
              <el-rate
                :colors="['#FC9153', '#FC9153', '#FC9153']"
                v-model="star"
              ></el-rate>
            </div>
          </div>
          <div class="box-item-text">
            <div>
              <span class="text-title">名字：</span
              ><span class="text-value">导入杯测</span>
            </div>
            <div>
              <span class="text-title">烘焙度：</span
              ><span class="text-value">70%</span>
            </div>
            <div>
              <span class="text-title">得分：</span
              ><span class="text-value">57.69</span>
            </div>
            <div>
              <span class="text-title">登记：</span
              ><span class="text-value">良好</span>
            </div>
          </div>
        </div>
        <div class="box-item box-half">
          <div class="box-item-img">
            <img src="../../assets/img/编组18@2x.png" />
            <div class="datetime">
              <el-rate
                :colors="['#FC9153', '#FC9153', '#FC9153']"
                v-model="star"
              ></el-rate>
            </div>
          </div>
          <div class="box-item-text">
            <div>
              <span class="text-title">名字：</span
              ><span class="text-value">导入杯测</span>
            </div>
            <div>
              <span class="text-title">烘焙度：</span
              ><span class="text-value">70%</span>
            </div>
            <div>
              <span class="text-title">得分：</span
              ><span class="text-value">57.69</span>
            </div>
            <div>
              <span class="text-title">登记：</span
              ><span class="text-value">良好</span>
            </div>
          </div>
        </div>
      </div>
      <div class="box-content" v-if="active1 == 2">
        <div class="box-item box-half box-active">
          <div class="box-item-img">
            <img src="../../assets/img/编组18@2x.png" />
            <div class="datetime">
              <el-rate
                :colors="['#FC9153', '#FC9153', '#FC9153']"
                v-model="star"
              ></el-rate>
            </div>
          </div>
          <div class="box-item-text">
            <div>
              <span class="text-title">名字：</span
              ><span class="text-value">导入杯测</span>
            </div>
            <div>
              <span class="text-title">烘焙度：</span
              ><span class="text-value">70%</span>
            </div>
            <div>
              <span class="text-title">得分：</span
              ><span class="text-value">57.69</span>
            </div>
            <div>
              <span class="text-title">登记：</span
              ><span class="text-value">良好</span>
            </div>
          </div>
        </div>
        <div class="box-item box-half">
          <div class="box-item-img">
            <img src="../../assets/img/编组18@2x.png" />
            <div class="datetime">
              <el-rate
                :colors="['#FC9153', '#FC9153', '#FC9153']"
                v-model="star"
              ></el-rate>
            </div>
          </div>
          <div class="box-item-text">
            <div>
              <span class="text-title">名字：</span
              ><span class="text-value">导入杯测</span>
            </div>
            <div>
              <span class="text-title">烘焙度：</span
              ><span class="text-value">70%</span>
            </div>
            <div>
              <span class="text-title">得分：</span
              ><span class="text-value">57.69</span>
            </div>
            <div>
              <span class="text-title">登记：</span
              ><span class="text-value">良好</span>
            </div>
          </div>
        </div>
        <div class="box-item box-half">
          <div class="box-item-img">
            <img src="../../assets/img/编组18@2x.png" />
            <div class="datetime">
              <el-rate
                :colors="['#FC9153', '#FC9153', '#FC9153']"
                v-model="star"
              ></el-rate>
            </div>
          </div>
          <div class="box-item-text">
            <div>
              <span class="text-title">名字：</span
              ><span class="text-value">导入杯测</span>
            </div>
            <div>
              <span class="text-title">烘焙度：</span
              ><span class="text-value">70%</span>
            </div>
            <div>
              <span class="text-title">得分：</span
              ><span class="text-value">57.69</span>
            </div>
            <div>
              <span class="text-title">登记：</span
              ><span class="text-value">良好</span>
            </div>
          </div>
        </div>
        <div class="box-item box-half">
          <div class="box-item-img">
            <img src="../../assets/img/编组18@2x.png" />
            <div class="datetime">
              <el-rate
                :colors="['#FC9153', '#FC9153', '#FC9153']"
                v-model="star"
              ></el-rate>
            </div>
          </div>
          <div class="box-item-text">
            <div>
              <span class="text-title">名字：</span
              ><span class="text-value">导入杯测</span>
            </div>
            <div>
              <span class="text-title">烘焙度：</span
              ><span class="text-value">70%</span>
            </div>
            <div>
              <span class="text-title">得分：</span
              ><span class="text-value">57.69</span>
            </div>
            <div>
              <span class="text-title">登记：</span
              ><span class="text-value">良好</span>
            </div>
          </div>
        </div>
        <div class="box-item box-half">
          <div class="box-item-img">
            <img src="../../assets/img/编组18@2x.png" />
            <div class="datetime">
              <el-rate
                :colors="['#FC9153', '#FC9153', '#FC9153']"
                v-model="star"
              ></el-rate>
            </div>
          </div>
          <div class="box-item-text">
            <div>
              <span class="text-title">名字：</span
              ><span class="text-value">导入杯测</span>
            </div>
            <div>
              <span class="text-title">烘焙度：</span
              ><span class="text-value">70%</span>
            </div>
            <div>
              <span class="text-title">得分：</span
              ><span class="text-value">57.69</span>
            </div>
            <div>
              <span class="text-title">登记：</span
              ><span class="text-value">良好</span>
            </div>
          </div>
        </div>
        <div class="box-item box-half">
          <div class="box-item-img">
            <img src="../../assets/img/编组18@2x.png" />
            <div class="datetime">
              <el-rate
                :colors="['#FC9153', '#FC9153', '#FC9153']"
                v-model="star"
              ></el-rate>
            </div>
          </div>
          <div class="box-item-text">
            <div>
              <span class="text-title">名字：</span
              ><span class="text-value">导入杯测</span>
            </div>
            <div>
              <span class="text-title">烘焙度：</span
              ><span class="text-value">70%</span>
            </div>
            <div>
              <span class="text-title">得分：</span
              ><span class="text-value">57.69</span>
            </div>
            <div>
              <span class="text-title">登记：</span
              ><span class="text-value">良好</span>
            </div>
          </div>
        </div>
        <div class="box-item box-half">
          <div class="box-item-img">
            <img src="../../assets/img/编组18@2x.png" />
            <div class="datetime">
              <el-rate
                :colors="['#FC9153', '#FC9153', '#FC9153']"
                v-model="star"
              ></el-rate>
            </div>
          </div>
          <div class="box-item-text">
            <div>
              <span class="text-title">名字：</span
              ><span class="text-value">导入杯测</span>
            </div>
            <div>
              <span class="text-title">烘焙度：</span
              ><span class="text-value">70%</span>
            </div>
            <div>
              <span class="text-title">得分：</span
              ><span class="text-value">57.69</span>
            </div>
            <div>
              <span class="text-title">登记：</span
              ><span class="text-value">良好</span>
            </div>
          </div>
        </div>
        <div class="box-item box-half">
          <div class="box-item-img">
            <img src="../../assets/img/编组18@2x.png" />
            <div class="datetime">
              <el-rate
                :colors="['#FC9153', '#FC9153', '#FC9153']"
                v-model="star"
              ></el-rate>
            </div>
          </div>
          <div class="box-item-text">
            <div>
              <span class="text-title">名字：</span
              ><span class="text-value">导入杯测</span>
            </div>
            <div>
              <span class="text-title">烘焙度：</span
              ><span class="text-value">70%</span>
            </div>
            <div>
              <span class="text-title">得分：</span
              ><span class="text-value">57.69</span>
            </div>
            <div>
              <span class="text-title">登记：</span
              ><span class="text-value">良好</span>
            </div>
          </div>
        </div>
        <div class="box-item box-half">
          <div class="box-item-img">
            <img src="../../assets/img/编组18@2x.png" />
            <div class="datetime">
              <el-rate
                :colors="['#FC9153', '#FC9153', '#FC9153']"
                v-model="star"
              ></el-rate>
            </div>
          </div>
          <div class="box-item-text">
            <div>
              <span class="text-title">名字：</span
              ><span class="text-value">导入杯测</span>
            </div>
            <div>
              <span class="text-title">烘焙度：</span
              ><span class="text-value">70%</span>
            </div>
            <div>
              <span class="text-title">得分：</span
              ><span class="text-value">57.69</span>
            </div>
            <div>
              <span class="text-title">登记：</span
              ><span class="text-value">良好</span>
            </div>
          </div>
        </div>
        <div class="box-item box-half">
          <div class="box-item-img">
            <img src="../../assets/img/编组18@2x.png" />
            <div class="datetime">
              <el-rate
                :colors="['#FC9153', '#FC9153', '#FC9153']"
                v-model="star"
              ></el-rate>
            </div>
          </div>
          <div class="box-item-text">
            <div>
              <span class="text-title">名字：</span
              ><span class="text-value">导入杯测</span>
            </div>
            <div>
              <span class="text-title">烘焙度：</span
              ><span class="text-value">70%</span>
            </div>
            <div>
              <span class="text-title">得分：</span
              ><span class="text-value">57.69</span>
            </div>
            <div>
              <span class="text-title">登记：</span
              ><span class="text-value">良好</span>
            </div>
          </div>
        </div>
      </div>
      <div class="box-content" v-if="active1 == 3">
        <div class="box-item box-half box-active">
          <div class="box-item-img">
            <img src="../../assets/img/编组18@2x.png" />
            <div class="datetime">
              <el-rate
                :colors="['#FC9153', '#FC9153', '#FC9153']"
                v-model="star"
              ></el-rate>
            </div>
          </div>
          <div class="box-item-text">
            <div>
              <span class="text-title">名字：</span
              ><span class="text-value">导入杯测</span>
            </div>
            <div>
              <span class="text-title">烘焙度：</span
              ><span class="text-value">70%</span>
            </div>
            <div>
              <span class="text-title">得分：</span
              ><span class="text-value">57.69</span>
            </div>
            <div>
              <span class="text-title">登记：</span
              ><span class="text-value">良好</span>
            </div>
          </div>
        </div>
        <div class="box-item box-half">
          <div class="box-item-img">
            <img src="../../assets/img/编组18@2x.png" />
            <div class="datetime">
              <el-rate
                :colors="['#FC9153', '#FC9153', '#FC9153']"
                v-model="star"
              ></el-rate>
            </div>
          </div>
          <div class="box-item-text">
            <div>
              <span class="text-title">名字：</span
              ><span class="text-value">导入杯测</span>
            </div>
            <div>
              <span class="text-title">烘焙度：</span
              ><span class="text-value">70%</span>
            </div>
            <div>
              <span class="text-title">得分：</span
              ><span class="text-value">57.69</span>
            </div>
            <div>
              <span class="text-title">登记：</span
              ><span class="text-value">良好</span>
            </div>
          </div>
        </div>
        <div class="box-item box-half">
          <div class="box-item-img">
            <img src="../../assets/img/编组18@2x.png" />
            <div class="datetime">
              <el-rate
                :colors="['#FC9153', '#FC9153', '#FC9153']"
                v-model="star"
              ></el-rate>
            </div>
          </div>
          <div class="box-item-text">
            <div>
              <span class="text-title">名字：</span
              ><span class="text-value">导入杯测</span>
            </div>
            <div>
              <span class="text-title">烘焙度：</span
              ><span class="text-value">70%</span>
            </div>
            <div>
              <span class="text-title">得分：</span
              ><span class="text-value">57.69</span>
            </div>
            <div>
              <span class="text-title">登记：</span
              ><span class="text-value">良好</span>
            </div>
          </div>
        </div>
        <div class="box-item box-half">
          <div class="box-item-img">
            <img src="../../assets/img/编组18@2x.png" />
            <div class="datetime">
              <el-rate
                :colors="['#FC9153', '#FC9153', '#FC9153']"
                v-model="star"
              ></el-rate>
            </div>
          </div>
          <div class="box-item-text">
            <div>
              <span class="text-title">名字：</span
              ><span class="text-value">导入杯测</span>
            </div>
            <div>
              <span class="text-title">烘焙度：</span
              ><span class="text-value">70%</span>
            </div>
            <div>
              <span class="text-title">得分：</span
              ><span class="text-value">57.69</span>
            </div>
            <div>
              <span class="text-title">登记：</span
              ><span class="text-value">良好</span>
            </div>
          </div>
        </div>
        <div class="box-item box-half">
          <div class="box-item-img">
            <img src="../../assets/img/编组18@2x.png" />
            <div class="datetime">
              <el-rate
                :colors="['#FC9153', '#FC9153', '#FC9153']"
                v-model="star"
              ></el-rate>
            </div>
          </div>
          <div class="box-item-text">
            <div>
              <span class="text-title">名字：</span
              ><span class="text-value">导入杯测</span>
            </div>
            <div>
              <span class="text-title">烘焙度：</span
              ><span class="text-value">70%</span>
            </div>
            <div>
              <span class="text-title">得分：</span
              ><span class="text-value">57.69</span>
            </div>
            <div>
              <span class="text-title">登记：</span
              ><span class="text-value">良好</span>
            </div>
          </div>
        </div>
        <div class="box-item box-half">
          <div class="box-item-img">
            <img src="../../assets/img/编组18@2x.png" />
            <div class="datetime">
              <el-rate
                :colors="['#FC9153', '#FC9153', '#FC9153']"
                v-model="star"
              ></el-rate>
            </div>
          </div>
          <div class="box-item-text">
            <div>
              <span class="text-title">名字：</span
              ><span class="text-value">导入杯测</span>
            </div>
            <div>
              <span class="text-title">烘焙度：</span
              ><span class="text-value">70%</span>
            </div>
            <div>
              <span class="text-title">得分：</span
              ><span class="text-value">57.69</span>
            </div>
            <div>
              <span class="text-title">登记：</span
              ><span class="text-value">良好</span>
            </div>
          </div>
        </div>
        <div class="box-item box-half">
          <div class="box-item-img">
            <img src="../../assets/img/编组18@2x.png" />
            <div class="datetime">
              <el-rate
                :colors="['#FC9153', '#FC9153', '#FC9153']"
                v-model="star"
              ></el-rate>
            </div>
          </div>
          <div class="box-item-text">
            <div>
              <span class="text-title">名字：</span
              ><span class="text-value">导入杯测</span>
            </div>
            <div>
              <span class="text-title">烘焙度：</span
              ><span class="text-value">70%</span>
            </div>
            <div>
              <span class="text-title">得分：</span
              ><span class="text-value">57.69</span>
            </div>
            <div>
              <span class="text-title">登记：</span
              ><span class="text-value">良好</span>
            </div>
          </div>
        </div>
        <div class="box-item box-half">
          <div class="box-item-img">
            <img src="../../assets/img/编组18@2x.png" />
            <div class="datetime">
              <el-rate
                :colors="['#FC9153', '#FC9153', '#FC9153']"
                v-model="star"
              ></el-rate>
            </div>
          </div>
          <div class="box-item-text">
            <div>
              <span class="text-title">名字：</span
              ><span class="text-value">导入杯测</span>
            </div>
            <div>
              <span class="text-title">烘焙度：</span
              ><span class="text-value">70%</span>
            </div>
            <div>
              <span class="text-title">得分：</span
              ><span class="text-value">57.69</span>
            </div>
            <div>
              <span class="text-title">登记：</span
              ><span class="text-value">良好</span>
            </div>
          </div>
        </div>
        <div class="box-item box-half">
          <div class="box-item-img">
            <img src="../../assets/img/编组18@2x.png" />
            <div class="datetime">
              <el-rate
                :colors="['#FC9153', '#FC9153', '#FC9153']"
                v-model="star"
              ></el-rate>
            </div>
          </div>
          <div class="box-item-text">
            <div>
              <span class="text-title">名字：</span
              ><span class="text-value">导入杯测</span>
            </div>
            <div>
              <span class="text-title">烘焙度：</span
              ><span class="text-value">70%</span>
            </div>
            <div>
              <span class="text-title">得分：</span
              ><span class="text-value">57.69</span>
            </div>
            <div>
              <span class="text-title">登记：</span
              ><span class="text-value">良好</span>
            </div>
          </div>
        </div>
        <div class="box-item box-half">
          <div class="box-item-img">
            <img src="../../assets/img/编组18@2x.png" />
            <div class="datetime">
              <el-rate
                :colors="['#FC9153', '#FC9153', '#FC9153']"
                v-model="star"
              ></el-rate>
            </div>
          </div>
          <div class="box-item-text">
            <div>
              <span class="text-title">名字：</span
              ><span class="text-value">导入杯测</span>
            </div>
            <div>
              <span class="text-title">烘焙度：</span
              ><span class="text-value">70%</span>
            </div>
            <div>
              <span class="text-title">得分：</span
              ><span class="text-value">57.69</span>
            </div>
            <div>
              <span class="text-title">登记：</span
              ><span class="text-value">良好</span>
            </div>
          </div>
        </div>
        <div class="box-item box-half">
          <div class="box-item-img">
            <img src="../../assets/img/编组18@2x.png" />
            <div class="datetime">
              <el-rate
                :colors="['#FC9153', '#FC9153', '#FC9153']"
                v-model="star"
              ></el-rate>
            </div>
          </div>
          <div class="box-item-text">
            <div>
              <span class="text-title">名字：</span
              ><span class="text-value">导入杯测</span>
            </div>
            <div>
              <span class="text-title">烘焙度：</span
              ><span class="text-value">70%</span>
            </div>
            <div>
              <span class="text-title">得分：</span
              ><span class="text-value">57.69</span>
            </div>
            <div>
              <span class="text-title">登记：</span
              ><span class="text-value">良好</span>
            </div>
          </div>
        </div>
      </div>
      <div class="box-content" v-if="active1 == 4">
        <div class="box-item box-half box-active">
          <div class="box-item-img">
            <img src="../../assets/img/编组18@2x.png" />
            <div class="datetime">
              <el-rate
                :colors="['#FC9153', '#FC9153', '#FC9153']"
                v-model="star"
              ></el-rate>
            </div>
          </div>
          <div class="box-item-text">
            <div>
              <span class="text-title">名字：</span
              ><span class="text-value">导入杯测</span>
            </div>
            <div>
              <span class="text-title">烘焙度：</span
              ><span class="text-value">70%</span>
            </div>
            <div>
              <span class="text-title">得分：</span
              ><span class="text-value">57.69</span>
            </div>
            <div>
              <span class="text-title">登记：</span
              ><span class="text-value">良好</span>
            </div>
          </div>
        </div>
        <div class="box-item box-half">
          <div class="box-item-img">
            <img src="../../assets/img/编组18@2x.png" />
            <div class="datetime">
              <el-rate
                :colors="['#FC9153', '#FC9153', '#FC9153']"
                v-model="star"
              ></el-rate>
            </div>
          </div>
          <div class="box-item-text">
            <div>
              <span class="text-title">名字：</span
              ><span class="text-value">导入杯测</span>
            </div>
            <div>
              <span class="text-title">烘焙度：</span
              ><span class="text-value">70%</span>
            </div>
            <div>
              <span class="text-title">得分：</span
              ><span class="text-value">57.69</span>
            </div>
            <div>
              <span class="text-title">登记：</span
              ><span class="text-value">良好</span>
            </div>
          </div>
        </div>
        <div class="box-item box-half">
          <div class="box-item-img">
            <img src="../../assets/img/编组18@2x.png" />
            <div class="datetime">
              <el-rate
                :colors="['#FC9153', '#FC9153', '#FC9153']"
                v-model="star"
              ></el-rate>
            </div>
          </div>
          <div class="box-item-text">
            <div>
              <span class="text-title">名字：</span
              ><span class="text-value">导入杯测</span>
            </div>
            <div>
              <span class="text-title">烘焙度：</span
              ><span class="text-value">70%</span>
            </div>
            <div>
              <span class="text-title">得分：</span
              ><span class="text-value">57.69</span>
            </div>
            <div>
              <span class="text-title">登记：</span
              ><span class="text-value">良好</span>
            </div>
          </div>
        </div>
        <div class="box-item box-half">
          <div class="box-item-img">
            <img src="../../assets/img/编组18@2x.png" />
            <div class="datetime">
              <el-rate
                :colors="['#FC9153', '#FC9153', '#FC9153']"
                v-model="star"
              ></el-rate>
            </div>
          </div>
          <div class="box-item-text">
            <div>
              <span class="text-title">名字：</span
              ><span class="text-value">导入杯测</span>
            </div>
            <div>
              <span class="text-title">烘焙度：</span
              ><span class="text-value">70%</span>
            </div>
            <div>
              <span class="text-title">得分：</span
              ><span class="text-value">57.69</span>
            </div>
            <div>
              <span class="text-title">登记：</span
              ><span class="text-value">良好</span>
            </div>
          </div>
        </div>
        <div class="box-item box-half">
          <div class="box-item-img">
            <img src="../../assets/img/编组18@2x.png" />
            <div class="datetime">
              <el-rate
                :colors="['#FC9153', '#FC9153', '#FC9153']"
                v-model="star"
              ></el-rate>
            </div>
          </div>
          <div class="box-item-text">
            <div>
              <span class="text-title">名字：</span
              ><span class="text-value">导入杯测</span>
            </div>
            <div>
              <span class="text-title">烘焙度：</span
              ><span class="text-value">70%</span>
            </div>
            <div>
              <span class="text-title">得分：</span
              ><span class="text-value">57.69</span>
            </div>
            <div>
              <span class="text-title">登记：</span
              ><span class="text-value">良好</span>
            </div>
          </div>
        </div>
        <div class="box-item box-half">
          <div class="box-item-img">
            <img src="../../assets/img/编组18@2x.png" />
            <div class="datetime">
              <el-rate
                :colors="['#FC9153', '#FC9153', '#FC9153']"
                v-model="star"
              ></el-rate>
            </div>
          </div>
          <div class="box-item-text">
            <div>
              <span class="text-title">名字：</span
              ><span class="text-value">导入杯测</span>
            </div>
            <div>
              <span class="text-title">烘焙度：</span
              ><span class="text-value">70%</span>
            </div>
            <div>
              <span class="text-title">得分：</span
              ><span class="text-value">57.69</span>
            </div>
            <div>
              <span class="text-title">登记：</span
              ><span class="text-value">良好</span>
            </div>
          </div>
        </div>
        <div class="box-item box-half">
          <div class="box-item-img">
            <img src="../../assets/img/编组18@2x.png" />
            <div class="datetime">
              <el-rate
                :colors="['#FC9153', '#FC9153', '#FC9153']"
                v-model="star"
              ></el-rate>
            </div>
          </div>
          <div class="box-item-text">
            <div>
              <span class="text-title">名字：</span
              ><span class="text-value">导入杯测</span>
            </div>
            <div>
              <span class="text-title">烘焙度：</span
              ><span class="text-value">70%</span>
            </div>
            <div>
              <span class="text-title">得分：</span
              ><span class="text-value">57.69</span>
            </div>
            <div>
              <span class="text-title">登记：</span
              ><span class="text-value">良好</span>
            </div>
          </div>
        </div>
        <div class="box-item box-half">
          <div class="box-item-img">
            <img src="../../assets/img/编组18@2x.png" />
            <div class="datetime">
              <el-rate
                :colors="['#FC9153', '#FC9153', '#FC9153']"
                v-model="star"
              ></el-rate>
            </div>
          </div>
          <div class="box-item-text">
            <div>
              <span class="text-title">名字：</span
              ><span class="text-value">导入杯测</span>
            </div>
            <div>
              <span class="text-title">烘焙度：</span
              ><span class="text-value">70%</span>
            </div>
            <div>
              <span class="text-title">得分：</span
              ><span class="text-value">57.69</span>
            </div>
            <div>
              <span class="text-title">登记：</span
              ><span class="text-value">良好</span>
            </div>
          </div>
        </div>
        <div class="box-item box-half">
          <div class="box-item-img">
            <img src="../../assets/img/编组18@2x.png" />
            <div class="datetime">
              <el-rate
                :colors="['#FC9153', '#FC9153', '#FC9153']"
                v-model="star"
              ></el-rate>
            </div>
          </div>
          <div class="box-item-text">
            <div>
              <span class="text-title">名字：</span
              ><span class="text-value">导入杯测</span>
            </div>
            <div>
              <span class="text-title">烘焙度：</span
              ><span class="text-value">70%</span>
            </div>
            <div>
              <span class="text-title">得分：</span
              ><span class="text-value">57.69</span>
            </div>
            <div>
              <span class="text-title">登记：</span
              ><span class="text-value">良好</span>
            </div>
          </div>
        </div>
        <div class="box-item box-half">
          <div class="box-item-img">
            <img src="../../assets/img/编组18@2x.png" />
            <div class="datetime">
              <el-rate
                :colors="['#FC9153', '#FC9153', '#FC9153']"
                v-model="star"
              ></el-rate>
            </div>
          </div>
          <div class="box-item-text">
            <div>
              <span class="text-title">名字：</span
              ><span class="text-value">导入杯测</span>
            </div>
            <div>
              <span class="text-title">烘焙度：</span
              ><span class="text-value">70%</span>
            </div>
            <div>
              <span class="text-title">得分：</span
              ><span class="text-value">57.69</span>
            </div>
            <div>
              <span class="text-title">登记：</span
              ><span class="text-value">良好</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="main-box border-1px-all">
      <section>
        <div class="flex flex-between">
          <div class="title-bc">铁皮卡</div>
        </div>
        <div class="flex flex-center" style="margin:10px 0;">
          <el-button type="primary" class="bt-large"
            >烘焙日期：2021.04.23</el-button
          >
          <el-button type="primary" class="bt-large"
            ><el-rate
              :colors="['#FC9153', '#FC9153', '#FC9153']"
              v-model="star"
            ></el-rate
          ></el-button>
          <el-button type="primary" class="bt-large bt-state-box">
            <span class="bt-state bt-state-2"></span>
            添加收藏
          </el-button>
          <el-button type="primary" class="bt-large bt-state-box">
            <span class="bt-state bt-state-1"></span>
            添加推荐
          </el-button>
        </div>
        <div style="height:200px;text-align:center;line-height:200px;">
          曲线 echarts
        </div>
      </section>
      <el-divider></el-divider>
      <section>
        <div class="flex flex-center header-common">
          <span class="header-span header-span-active">咖啡豆</span>
        </div>
        <div class="has-total-table">
          <el-table
            :data="gridData1"
            border
            style="width:calc(100% - 1px);"
            class="has-total-table"
          >
            <el-table-column
              property="key1"
              :label="$t('m.table.name')"
            ></el-table-column>
            <el-table-column
              property="key2"
              label="类别"
              width="80"
            ></el-table-column>
            <el-table-column property="key3" label="事件"></el-table-column>
            <el-table-column
              property="key4"
              label="时间"
              width="100"
            ></el-table-column>
            <el-table-column
              property="key5"
              label="重量"
              width="80"
            ></el-table-column>
          </el-table>
          <div class="table-totla-line">
            <span class="gray-text">总重量:</span>
            <span class="white-text">650kg</span>
          </div>
        </div>
      </section>
      <section>
        <div class="flex flex-center header-common">
          <span class="header-span header-span-active">描述</span>
        </div>
        <div class="row-box" style="margin-top: 0px">
          <el-row>
            <el-col :span="12">
              <div class="flex flex-between">
                <span class="gray-text">序列号：</span>
                <span class="white-text">23213123123</span>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="flex flex-between">
                <span class="gray-text">机器型号：</span>
                <span class="white-text">43242</span>
              </div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <div class="flex flex-between">
                <span class="gray-text">烘焙时长：</span>
                <span class="white-text"></span>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="flex flex-between">
                <span class="gray-text">发展时间：</span>
                <span class="white-text">2021.06.01</span>
              </div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <div class="flex flex-between">
                <span class="gray-text">发展率：</span>
                <span class="white-text">15</span>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="flex flex-between">
                <span class="gray-text">入豆温：</span>
                <span class="white-text">生豆一</span>
              </div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <div class="flex flex-between">
                <span class="gray-text">回温点：</span>
                <span class="white-text">导入</span>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="flex flex-between">
                <span class="gray-text">转黄点：</span>
                <span class="white-text">540kg</span>
              </div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <div class="flex flex-between">
                <span class="gray-text">一爆：</span>
                <span class="white-text">340</span>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="flex flex-between">
                <span class="gray-text">二爆：</span>
                <span class="white-text">540kg</span>
              </div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <div class="flex flex-between">
                <span class="gray-text">结束：</span>
                <span class="white-text">Light:8</span>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="flex flex-between">
                <span class="gray-text">回温至黄点温升：</span>
                <span class="white-text"></span>
              </div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <div class="flex flex-between">
                <span class="gray-text">黄点至一爆温升：</span>
                <span class="white-text">Light:8</span>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="flex flex-between">
                <span class="gray-text">一爆至结束温升：</span>
                <span class="white-text"></span>
              </div>
            </el-col>
          </el-row>
        </div>
      </section>
      <section>
        <div class="flex flex-center header-common">
          <span class="header-span header-span-active">过程</span>
        </div>
        <el-table
          :data="gridData2"
          border
          class="mini-table"
          style="width:calc(100% - 1px);"
        >
          <el-table-column
            property="key1"
            width="60px"
            label="时间"
          ></el-table-column>
          <el-table-column
            property="key2"
            width="44px"
            label="豆温"
          ></el-table-column>
          <el-table-column
            property="key3"
            width="80px"
            label="ROR"
          ></el-table-column>
          <el-table-column
            property="key4"
            width="50px"
            label="热风温"
          ></el-table-column>
          <el-table-column
            property="key5"
            width="50px"
            label="出风温"
          ></el-table-column>
          <el-table-column
            property="key6"
            width="50px"
            label="环境温"
          ></el-table-column>
          <el-table-column
            property="key7"
            width="40px"
            label="火力"
          ></el-table-column>
          <el-table-column
            property="key8"
            width="40px"
            label="热风"
          ></el-table-column>
          <el-table-column
            property="key9"
            width="40px"
            label="滚筒"
          ></el-table-column>
          <el-table-column property="key10" label="标记"></el-table-column>
        </el-table>
      </section>
      <section>
        <div class="flex" style="justify-content:flex-end;margin-top:20px;">
          <div class="line-right">
            <el-button type="primary">导出PDF</el-button>
            <el-button type="primary">导出JSON</el-button>
          </div>
        </div>
      </section>
    </div>
    <!--------搜索弹框---------->
    <el-dialog
      title="搜索"
      :visible.sync="dialogTableVisible"
      width="500px"
      :show-close="false"
    >
      <div>
        <div class="flex flex-center flex-between" style="margin-bottom:10px;">
          <span class="search-dialog-title">按序列号</span>
          <el-input placeholder="请输入"> </el-input>
        </div>
        <div class="flex flex-center flex-between" style="margin-bottom:10px;">
          <span class="search-dialog-title">按用户名</span>
          <el-input placeholder="请输入"> </el-input>
        </div>
        <div class="flex flex-center flex-between" style="margin-bottom:10px;">
          <span class="search-dialog-title">按手机号</span>
          <el-input placeholder="请输入"> </el-input>
        </div>
        <div class="flex flex-center flex-between" style="margin-bottom:10px;">
          <span class="search-dialog-title">按地址</span>
          <el-input placeholder="请输入"> </el-input>
        </div>
      </div>
      <div slot="footer" class="flex flex-center">
        <div @click="dialogTableVisible = false" class="dialog-footer-btn">
          {{ $t("m.chart.table.cancel") }}
        </div>
        <div
          type="primary"
          @click="dialogTableVisible = false"
          class="dialog-footer-btn"
        >
          {{ $t("m.chart.table.confirm") }}
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      active1: 1,
      star: 2,
      dialogTableVisible: false,
      gridData1: [
        {
          key1: "卡图拉",
          key2: "Grade2",
          key3: "密处理",
          key4: "2021.06.25",
          key5: "850kg",
        },
        {
          key1: "新世界",
          key2: "Grade2",
          key3: "密处理",
          key4: "2021.06.25",
          key5: "850kg",
        },
        {
          key1: "斯考特实验室精选",
          key2: "Grade2",
          key3: "密处理",
          key4: "2021.06.25",
          key5: "850kg",
        },
        {
          key1: "法国传教士",
          key2: "Grade2",
          key3: "密处理",
          key4: "2021.06.25",
          key5: "850kg",
        },
        {
          key1: "铁皮卡",
          key2: "Grade2",
          key3: "密处理",
          key4: "2021.06.25",
          key5: "850kg",
        },
      ],
      gridData2: [
        {
          key1: "00:00",
          key2: "10℃",
          key3: "10℃/Min",
          key4: "10℃",
          key5: "10℃",
          key6: "10℃",
          key7: "30",
          key8: "30",
          key9: "30",
          key10: "空",
        },
        {
          key1: "00:00",
          key2: "10℃",
          key3: "10℃/Min",
          key4: "10℃",
          key5: "10℃",
          key6: "10℃",
          key7: "30",
          key8: "30",
          key9: "30",
          key10: "空",
        },
        {
          key1: "00:00",
          key2: "10℃",
          key3: "10℃/Min",
          key4: "10℃",
          key5: "10℃",
          key6: "10℃",
          key7: "30",
          key8: "30",
          key9: "30",
          key10: "空",
        },
        {
          key1: "00:00",
          key2: "10℃",
          key3: "10℃/Min",
          key4: "10℃",
          key5: "10℃",
          key6: "10℃",
          key7: "30",
          key8: "30",
          key9: "30",
          key10: "空",
        },
        {
          key1: "00:00",
          key2: "10℃",
          key3: "10℃/Min",
          key4: "10℃",
          key5: "10℃",
          key6: "10℃",
          key7: "30",
          key8: "30",
          key9: "30",
          key10: "空",
        },
      ],
    };
  },
  methods: {
    handleChange() {},
  },
};
</script>
